import React from 'react';
import { ProductId } from 'services/products/types';
import { useSelector } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import {
    FertilizerEntityIds,
    FertilizerEventProduct,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectProductTotal } from './selectors';

export interface Props {
    productId: ProductId;
    entityIds: FertilizerEntityIds;
    product: FertilizerEventProduct;
    unitTypeId: UnitTypeId;
    perUnitType: FertilizerProductPerUnitType;
}

export default function FertilizerEventProductTotalListItem(
    props: Props
): React.ReactElement {
    const productTotal = useSelector((state: AppState) =>
        makeSelectProductTotal()(state, props)
    );

    return <ListItem value={productTotal} description="Product total" />;
}
